import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as disputesService from '../../services/disputeService';
import disputeActionConstants from '../constants/disputeActionConstants';
import globalActionConstants from '../constants/globalActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const getDisputes = (page, perPage, searchTerm, disputeFilters, disputePageFilter) => async (dispatch) => {
  dispatch({ type: disputeActionConstants.GET_DISPUTES });

  const response = await disputesService.getDisputes(page, perPage, searchTerm, disputeFilters, disputePageFilter);
  if (response.data.response_code === responseCodes.OK) {
    dispatch({ type: disputeActionConstants.GET_DISPUTES_SUCCESS, payload: response.data.payload });
  } else {
    dispatch({ type: disputeActionConstants.GET_DISPUTES_ERROR });
    Notification.error(response.data.error.message || response.data.error);
  }
};

export const getDisputeDetails = (disputeId) => async (dispatch) => {
  try {
    dispatch({ type: globalActionConstants.SET_LOADING_ON });
    const response = await disputesService.getDisputeDetails(disputeId);
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: disputeActionConstants.GET_DISPUTE_DETAILS, payload: response.data.payload });
    } else {
      dispatch({ type: disputeActionConstants.GET_DISPUTE_DETAILS });
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};

export const postDisputeClose = (disputeId, successCb) => async (dispatch) => {
  try {
    dispatch({ type: globalActionConstants.SET_LOADING_ON });
    const response = await disputesService.postDisputeClose(disputeId);
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: disputeActionConstants.MARK_DISPUTE_CLOSE, payload: disputeId });
      successCb();
      Notification.success(t('notifications.disputeClosed'));
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};

export const postDeclineRequestClose = (data, successCb) => async (dispatch) => {
  try {
    dispatch({ type: globalActionConstants.SET_LOADING_ON });
    const response = await disputesService.postDeclineRequestClose(data);
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: disputeActionConstants.MARK_DISPUTE_OPEN, payload: data.disputeId });
      successCb();
      Notification.success(t('notifications.disputeClosed'));
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};

export const createDispute = (reason, details, payoutId, successCallback) => async (dispatch) => {
  dispatch({ type: disputeActionConstants.CREATE_DISPUTE });

  const response = await disputesService.postDispute(reason, details, payoutId);
  if (response.data.response_code === responseCodes.OK) {
    dispatch({ type: disputeActionConstants.CREATE_DISPUTE_SUCCESS, payload: response.data.payload });

    if (successCallback) successCallback();
  } else {
    dispatch({ type: disputeActionConstants.CREATE_DISPUTE_ERROR });
    Notification.error(response.data.error);
  }
};

export const getDisputeFiltersData = () => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await disputesService.getDisputeFiltersData();
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: disputeActionConstants.GET_DISPUTE_FILTERS_DATA, payload: response.data.payload });
    } else {
      dispatch({ type: disputeActionConstants.GET_DISPUTE_FILTERS_DATA_ERROR });
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};
